import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TableContainer from '@material-ui/core/TableContainer';

import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';

import ChartImpliedWaccData from 'pages/Entrepeneur/Feedbacks/charts/ChartImpliedWaccData';
import SelectComponent from './Select';
import ValuationTable from './ValuationTable';
import SendModal from './SendModal';
import ExportButton from './ExportButton';
import OutputTable from './OutputTable';
import ButtonPeer from './ButtonPeer';
import PeerOperatingModal from './PeerOperatingModal/PeerOperatingModal';
import OutputCash from './OutputCash';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0'
  },
  tableContainer: {
    borderTop: '5px solid #2DB9C4',
    marginBottom: 50
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',

    '& p': {
      marginLeft: 20,
      fontSize: 12
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  inputContainer: {
    padding: 30,
    background: 'rgba(151,151,151,0.1)',
    '& p': {
      color: '#001E41',
      fontSize: 20
    }
  },
  outputContainer: {
    '& p': {
      color: '#001E41',
      fontSize: 20,
      margin: 30
    }
  },
  tables: {
    display: 'flex'
  },
  datasContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  dataviz: {
    width: '50%',
    '& h3': {
      fontSize: 14,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      color: '#6D7278'
    },
    '& h2': {
      margin: 50
    }
  },
  input: {
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  inputDatas: {
    width: '50%',
    padding: 50
  },
  entry: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '5px 0',
    padding: '0 95px 0 20px',
    '& p': {
      fontSize: 12
    }
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rightButtons: {
    display: 'flex',
    alignItems: 'center'
  },
  percentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& span': {
      marginLeft: 2,
      color: '#002380',
      fontWeight: 600
    }
  },
  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px',
    marginLeft: '30px'
  },
  save: {
    background: '#6D7278',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#FFF',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 30,
    '& p': {
      fontSize: 10,
      color: '#515151'
    }
  }
}));

const Valuation = () => {
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [peerModalOpen, setPeerModalOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      {peerModalOpen && (
        <PeerOperatingModal
          onClose={() => setPeerModalOpen(false)}
          open={peerModalOpen}
        />
      )}
      {sendModalOpen && (
        <SendModal
          onClose={() => setSendModalOpen(false)}
          open={sendModalOpen}
        />
      )}
      <h5>You can build your own based on different sources of data</h5>
      <div className={classes.container}>
        {/* header */}
        <SelectComponent />
      </div>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <div className={classes.header}>
          <h2>Trading Multiple Analysis</h2>
        </div>

        <Paper className={classes.inputContainer}>
          <h5>Input</h5>
          <div className={classes.tables}>
            <ValuationTable
              rows={['Lyft', 'Uber Technologies']}
              textButton="add another company"
              title="Selection of peer group"
            />
            <ValuationTable
              rows={['EV / Revenue', 'EV / EBITDA', 'EV / EBITA', 'PE']}
              textButton="add another multiple"
              title="Selection of multiples"
            />
          </div>
        </Paper>
        <div className={classes.outputContainer}>
          <p>Output</p>
          <OutputTable />
          <div className={classes.footer}>
            <p>Source: Capital IQ</p>
            <ButtonPeer click={() => setPeerModalOpen(true)} />
          </div>
        </div>
      </TableContainer>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <div className={classes.header}>
          <h2>Discount cash flow analysis</h2>
        </div>

        <Paper className={classes.inputContainer}>
          <p>Input</p>
          <div className={classes.datasContainer}>
            <div className={classes.inputDatas}>
              <div className={classes.entry}>
                <p>Wacc</p>
                <div className={classes.percentContainer}>
                  <input className={classes.input} value={12.5} />
                  <span>%</span>
                </div>
              </div>
              <div className={classes.entry}>
                <p>Revenues Growth Rate from 2024 to 2028</p>
                <div className={classes.percentContainer}>
                  <input className={classes.input} value={5} />
                  <span>%</span>
                </div>
              </div>
              <div className={classes.entry}>
                <p>EBITDA Growth Rate from 2024 to 2028</p>
                <div className={classes.percentContainer}>
                  <input className={classes.input} value={57} />
                  <span>%</span>
                </div>
              </div>
              <div className={classes.entry}>
                <p>Terminal Growth Rate</p>
                <div className={classes.percentContainer}>
                  <input className={classes.input} value={2} />
                  <span>%</span>
                </div>
              </div>
            </div>
            <div className={classes.dataviz}>
              {/* <h3>
                Implied WACC derived from current share price and based on
                consensus
              </h3> */}
              <ChartImpliedWaccData />
            </div>
          </div>
        </Paper>
        <div className={classes.outputContainer}>
          <p>Output</p>
          <OutputCash />
        </div>
      </TableContainer>
      <div className={classes.buttonDiv}>
        <div>
          <Button className={classes.save} variant="contained">
            save
          </Button>
        </div>
        <div className={classes.rightButtons}>
          <ExportButton />
          <Button
            className={classes.send}
            color="primary"
            onClick={() => {}}
            variant="contained">
            send to issuer
          </Button>
        </div>
      </div>
    </>
  );
};

export default Valuation;
